// @flow
import React from 'react';
import styled, { type StyledComponent } from 'styled-components';

import Input from '@rover/react-lib/components/formFields/Input';
import HorizontalLayout from '@rover/react-lib/components/layouts/HorizontalLayout';
import { ALIGNMENT } from '@rover/react-lib/components/layouts/layout.constants';
import { FontWeight } from '@rover/react-lib/styles/Font';

type BigRadioWrapperProps = React$ElementConfig<typeof HorizontalLayout>;

const BigRadioWrapper: StyledComponent<BigRadioWrapperProps> = styled(HorizontalLayout)`
  cursor: pointer;

  & .form-group {
    margin: 0 !important;
  }
`;

type BigRadioProps = {
  ...React$ElementConfig<typeof Input>,
  checked?: boolean,
};

const BigRadio: StyledComponent<BigRadioProps> = styled(Input)`
  width: 28px;

  & input {
    width: 28px;
    height: 18px;
    margin: 0 !important;
    cursor: pointer;
  }
`;

const StyledLabel: StyledComponent<{}> = styled.label`
  font-weight: ${FontWeight.NORMAL};
  cursor: pointer;
  display: block;

  > * {
    pointer-events: none;
  }
`;

export type Props = {
  name?: string,
  id: ?string,
  value: number | string,
  label?: ?string,
  checked?: boolean,
  sensitive?: boolean,
  onChange: (?number | ?string) => void,
};

const BigRadioButton = ({
  name,
  id,
  value,
  label,
  checked,
  sensitive,
  onChange,
  ...other
}: Props) => (
  <BigRadioWrapper vAlign={ALIGNMENT.CENTER} {...other}>
    <BigRadio
      type="radio"
      name={name}
      id={id || ''}
      value={value}
      checked={checked}
      sensitive={sensitive}
      data-qa-id="components-buttons-big-radio-radio"
      onChange={() => onChange(value)}
    />
    {label && <StyledLabel htmlFor={id}>{label}</StyledLabel>}
  </BigRadioWrapper>
);

BigRadioButton.defaultProps = {
  id: undefined,
  label: undefined,
  checked: false,
  sensitive: false,
};

export default BigRadioButton;



// WEBPACK FOOTER //
// ../react-lib/src/components/buttons/BigRadioButton/BigRadioButton.jsx